var React = require('react');

function BlackAries (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.8401,1.3938c-1.9518,0-3.6852.9401-4.7704,2.3843-1.174,1.5656-2.1504,3.4595-2.8965,6.0432-.747-2.5837-1.7225-4.4767-2.8965-6.0423-1.0852-1.4442-2.8195-2.3852-4.7713-2.3852-3.2935,0-5.9634,2.6698-5.9634,5.9634s2.6699,5.9644,5.9634,5.9644h.8522v-3.4088h-.8522c-1.4116,0-2.5556-1.1441-2.5556-2.5556s1.144-2.5557,2.5556-2.5557c.835,0,1.5756.398,2.0452,1.0226,2.2012,2.9346,3.9137,7.8355,3.9182,21.0706v.058h3.4078v-.0598c.0054-13.2341,1.718-18.1342,3.9191-21.0687.4696-.6246,1.2103-1.0226,2.0443-1.0226,1.4116,0,2.5566,1.1441,2.5566,2.5557s-1.145,2.5556-2.5566,2.5556h-.8513v3.4088h.8513c3.2945,0,5.9644-2.6708,5.9644-5.9644s-2.6699-5.9634-5.9644-5.9634h0Z","fill":"#ebc192","strokeWidth":"0"}));
}

BlackAries.defaultProps = {"id":"Layer_1","data-name":"Layer 1","version":"1.1","viewBox":"0 0 28.3465 28.3465"};

module.exports = BlackAries;

BlackAries.default = BlackAries;
